export default __webpack_public_path__ + "static/media/gallery_06.4d1d2125.jpg";